import { defineNuxtRouteMiddleware, useNuxtApp } from "#app";
export default defineNuxtRouteMiddleware(async () => {
  const { $auth } = useNuxtApp();
  if ($auth && !$auth.initialized) {
    if (process.server) {
      await $auth.initServer();
    } else {
      $auth.initClient();
    }
  }
});
